// Chatbot Widget Loader
// This script loads the chatbot widget from the built library

(function() {
  // Load the chatbot CSS
  const cssLink = document.createElement('link');
  cssLink.rel = 'stylesheet';
  cssLink.href = '/chatbot/sentellent-core-frontend-template.css';
  document.head.appendChild(cssLink);

  // Load the chatbot widget script
  const script = document.createElement('script');
  script.src = '/chatbot/chatbot-widget.umd.js';
  script.async = true;

  script.onload = function() {
    // Initialize the chatbot once the script is loaded
    if (window.initChatbot) {
      window.initChatbot('chatbot-root');
    } else {
      console.error('Chatbot initialization function not found');
    }
  };

  script.onerror = function() {
    console.error('Failed to load chatbot widget script');
  };

  document.head.appendChild(script);
})();
